import { defineStore } from 'pinia';
export const useCompanySizeStore = defineStore('company-sizes', {
    state: () => ({
        companySizes: [] as any[],
        companySize: null as any | null,
    }),
    actions: {
        async fetchCompanySizes() {
            return useNuxtApp().$api().v2.companySizes.list({
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.companySizes = response
                return response;
            });
        },
        async fetchCompanySize(id: string) {
            this.companySize = await useNuxtApp().$api().v2.companySizes.get(id);
        },
    }
})